import Image from 'components/Common/Image'
import LineAngleRightBIcon from 'LuxKit/Icons/line/LineAngleRightBIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { CHOOSE_DOUBLE_REWARDS_IMAGE_ID, CHOOSE_DOUBLE_REWARDS_SLUG } from '../loyaltyChooseDoubleRewardsTakeover.constants'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import { useCallback } from 'react'
import useLoyaltyChooseDoubleRewardsTracking from '../hooks/useLoyaltyChooseDoubleRewardsTracking'

const Item = styled(ClickableListItem)`
  gap: ${rem(8)};
  padding: ${rem(8)};
  background: ${props => props.theme.palette.neutral.surface.lightBackground};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.L};
`

const Thumbnail = styled(Image)`
  width: ${rem(48)};
  height: ${rem(48)};
  flex: 0 0 auto;
  border-radius: ${props => props.theme.borderRadius.M};
`

const UrgencyLabel = styled.span`
  color: ${props => props.theme.palette.messaging.urgency.normalForeground};
`

interface Props {
  onNavigate: () => void
}

function NavBarHamburgerMenuLoyaltyChooseDoubleRewardsCardBanner({ onNavigate }: Props) {
  const { impressionRef, track } = useLoyaltyChooseDoubleRewardsTracking('nav_entry')

  const onClick = useCallback(() => {
    track('clicked')
    onNavigate()
  }, [track, onNavigate])

  const intl = useIntl()

  const urgencyLabel = intl.formatMessage({
    id: 'gd-KHZkb4Q2721ydA9Ne',
    defaultMessage: 'Limited-time only',
    description: 'Limited time label for the double rewards promotion in the navigation drawer',
  })

  const title = intl.formatMessage({
    id: 'qwNkJnbIMlliS_AOQcQ-',
    defaultMessage: 'Double {programName} rewards',
    description: 'Title of the double rewards campaign item in the navigation drawer',
  }, { programName: getLoyaltyProgramDisplayName() })

  return <Item
    ref={impressionRef}
    size="medium"
    to={`/societe/${CHOOSE_DOUBLE_REWARDS_SLUG}`}
    onClick={onClick}
    startIcon={<Thumbnail id={CHOOSE_DOUBLE_REWARDS_IMAGE_ID} alt="" width={48} height={48} objectFit="cover" />}
    overline={<UrgencyLabel>{urgencyLabel}</UrgencyLabel>}
    title={title}
    endIcon={<LineAngleRightBIcon />}
  />
}

export default NavBarHamburgerMenuLoyaltyChooseDoubleRewardsCardBanner
